<template>
  <nav>
    <v-dialog v-model="dialog" data-testid="product-group-edit-dialog" fullscreen hide-overlay
      transition="dialog-bottom-transition" persistent>
      <v-card data-testid="edit-store-settings-group-card"> 
        <v-form ref="form" @submit.prevent>
          <v-toolbar dark color="accent">
            <v-btn data-testid="close-button" icon dark @click="onDialogClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editStoreSettingsTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn data-testid="submit-button" type="submit" :disabled="loading" color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="storeSettings ? updateStoreSettings() : createStoreSettings()">
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false">
          </AlertMessages>

          <v-card-text class="pt-0 pl-6">
            <div class="pt-15 px-md-12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-card-title>
                    {{ $t('invoceSettingsTitle') }}
                  </v-card-title>
                  <v-card-title class="pb-1">
                    {{ $t('organizationSettingsTitle') }}
                  </v-card-title>
                </v-col></v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field v-model="organizationName" data-testid="organization-name-input" solo
                    hide-details="auto" class="rounded-xxl text-body-2" :placeholder="$t('organizationNamePlaceholder')"
                    :rules="organizationNameRules" @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field v-model="organizationNumber" data-testid="organization-number-input" solo
                    hide-details="auto" class="rounded-xxl text-body-2"
                    :placeholder="$t('organizationNumberPlaceholder')" :rules="organizationNumberRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field v-model="organizationVatNumber" data-testid="vat-number-input" solo
                    hide-details="auto" class="rounded-xxl text-body-2" 
                    :placeholder="$t('organizationVatNumberPlaceholder')" :rules="organizationVatNumberRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="organizationPeppolNumber" data-testid="peppol-number-input" solo
                    hide-details="auto" class="rounded-xxl text-body-2" 
                    :placeholder="$t('organizationPeppolNumberPlaceholder')" :rules="organizationPeppolNumberRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="address" data-testid="company-address-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('addressPlaceholder')" :rules="addressRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field v-model="postCode" data-testid="post-code-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('postCodePlaceholder')" :rules="postCodeRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="city" data-testid="city-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('cityPlaceholder')" :rules="cityRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field v-model="country" data-testid="country-address-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('countryPlaceholder')" :rules="countryRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pt-0 pl-6">
            <div class=" px-md-12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-card-title class="pb-1">
                    {{ $t('contactSettingsTitle') }}
                  </v-card-title>
                </v-col></v-row>
              <v-row>
                <v-col cols="12" md="3">

                  <v-text-field v-model="firstName" data-testid="first-name-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('firstNamePlaceholder')" :rules="firstNameRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field v-model="lastName" data-testid="last-name-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('lastNamePlaceholder')" :rules="lastNameRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="email" data-testid="email-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('emailPlaceholder')" :rules="emailRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field v-model="websiteUrl" data-testid="website-url-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('websiteUrlPlaceholder')" :rules="websiteUrlRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="phoneNumber" data-testid="phone-number-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('phoneNumberPlaceholder')"
                    :rules="phoneNumberRules" @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pt-0 pl-6">
            <div class=" px-md-12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-card-title class="pb-1">
                    {{ $t('paymentSettingsTitle') }}
                  </v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">

                  <v-text-field v-model="accountName" data-testid="account-name-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('accountPlaceholder')" :rules="accountNameRules"
                    @keydown.enter.prevent="focusNext($event.target)" />
                </v-col>

                <v-col cols="12" md="3">
                  <v-select v-model="selectedDays" :placeholder="$t('dueDaysPlaceholder')" class="rounded-xxl "
                    :items="listDays" item-value="id" item-text="name" solo hide-details="true"
                    append-icon="mdi-chevron-down" dense data-testid="selected-days-select" />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pt-0 pl-6">
            <div class="px-md-12">
              <v-row>
                <v-col cols="12" md="3">
                  <v-card-title class="pb-1">
                    {{ $t('purchasePolicyTitle') }}
                  </v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="policyLinkText" data-testid="policy-link-text-input" solo hide-details="auto"
                    class="rounded-xxl text-body-2" :placeholder="$t('purchasePolicyLinkTextPlaceholder')"
                    @keydown.enter.prevent="focusNext($event.target)" :rules="policyLinkTextRules"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <editor-text-area-template class="editor editor-store-settings editor-text-area-template" :content="policyText"
                    :placeholder="$t('purchasePolicyTextPlaceholder')" data-testid="policy-text-input" @updateContent="updateContent" :key="updateEditor"
                  />
                  <v-dialog
                    data-testid="preview-policy-dialog"
                    v-model="dialogPreview"
                    scrollable
                    max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        data-testid="preview-policy-button"
                        color="accent"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="text-none no-text-transform no-hover"
                        text
                        :ripple="false"
                      >
                        {{ $t('previewPolicy') }}
                      </v-btn>
                    </template>
                    <v-card class="pa-5">
                      <v-row no-gutters>
                        <v-col cols="1" offset="11" class="justify-end text-right">
                          <v-icon
                            ref="cancel"
                            data-testid="cancel-button"
                            min-width="100"
                            class="rounded-xxl text-none mt-6 mb-2"
                            @click="dialogPreview = false"
                          >
                            mdi-close
                          </v-icon>
                        </v-col>
                      </v-row>
                      <v-card-text class="pa-0" style="height: 100%;">
                        <v-row class="content-block" style="background-color: #FFFFFF;">
                          <v-col class="column pt-0">
                              <v-img
                                  v-if="logo == null"
                                  data-testid="logo-space"
                                  src="../../assets/rtplogo.svg"
                                  max-height="40"
                                  max-width="150"
                                  class="d-none d-sm-block justify-center mb-5 default"
                                  contain
                      
                              />
                              <v-img
                                  v-else
                                  data-testid="logo-space"
                                  :src="logo"
                                  max-height="40"
                                  max-width="150"
                                  class="d-none d-sm-block justify-center mb-5"
                                  position="top left"
                                  contain
                                  
                              />
                              <div class="mb-5">
                                <p>{{ $t('labelOrganizationName')}} : {{ organizationName }}</p>
                                <p>{{ $t('labelOrganizationNumber')}} : {{ organizationNumber }}</p>
                                <p>{{ $t('labelAddress')}} : {{ address }}</p>
                                <p>{{ $t('labelPostCode')}} : {{ postCode }}</p>
                                <p>{{ $t('labelCity')}} : {{ city }}</p>
                                <p>{{ $t('labelCountry')}} : {{ country }}</p>
                              </div>
                              <div v-html="policyText"></div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import AlertMessages from '../../components/AlertMessages'
import { getStoreSettings, createStoreSettings, updateStoreSettings } from '../../api/productApi'
import i18n from '../../plugins/i18n'
import { ruleRequired, emailRuleValid, ruleValidMin2Max70Characters, ruleValidMinMax } from '../../rules/formRules.js';
import EditorTextAreaTemplate from '../../components/EditorTextAreaTemplate';

export default {

  components: {
    AlertMessages,
    EditorTextAreaTemplate
  },
  props: {
    visible: Boolean,

  },
  data() {
    return {
      //valid: true,
      alertMsg: '',
      alertType: '',
      alertValue: false,
      loading: false,
      spaceId: window.$cookies.get('space_id'),
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      organizationName: '',
      organizationNumber: '',
      address: '',
      city: '',
      postCode: '',
      accountName: '',
      country: '',
      websiteUrl: '',
      phoneNumber: '',
      countryRules: ruleRequired('labelCountry').concat(ruleValidMin2Max70Characters('labelCountry')),
      accountNameRules: ruleRequired('labelAccountName').concat(ruleValidMin2Max70Characters('labelAccountName')),
      organizationNameRules: ruleRequired('labelOrganizationName').concat(ruleValidMin2Max70Characters('labelOrganizationName')),
      firstNameRules: ruleRequired('labelFirstName').concat(ruleValidMin2Max70Characters('labelFirstName')),
      lastNameRules: ruleRequired('labelLastName').concat(ruleValidMin2Max70Characters('labelLastName')),
      emailRules: ruleRequired('labelEmail').concat(emailRuleValid).concat(ruleValidMinMax('labelEmail', 2 , 255)),
      companyNameRules: ruleRequired('labelCompanyName').concat(ruleValidMinMax('labelCompanyName', 2 , 255)),
      organizationNumberRules: ruleRequired('labelOrganizationNumber').concat(ruleValidMinMax('labelOrganizationNumber',2, 255)),
      addressRules: ruleRequired('labelAddress').concat(ruleValidMinMax('labelAddress', 2, 255)),
      cityRules: ruleRequired('labelCity').concat(ruleValidMinMax('labelCity', 2, 255)),
      postCodeRules: ruleRequired('labelPostCode').concat(ruleValidMinMax('labelPostCode', 2, 255)),
      websiteUrlRules: ruleRequired('labelWebsiteUrl').concat(ruleValidMinMax('labelWebsiteUrl', 2, 255)),
      phoneNumberRules: ruleRequired('labelPhoneNumber').concat(ruleValidMinMax('labelPhoneNumber', 2, 15)),
      organizationVatNumberRules: ruleValidMin2Max70Characters('organizationVatNumberPlaceholder'),
      organizationPeppolNumberRules: ruleValidMin2Max70Characters('organizationPeppolNumberPlaceholder'),
      listDays: [
        {
          id: 5,
          name: '5days'
        },
        {
          id: 10,
          name: '10days'
        },
        {
          id: 15,
          name: '15days'
        },
        {
          id: 20,
          name: '20days'
        },
        {
          id: 30,
          name: '30days'
        },
        {
          id: 60,
          name: '60days'
        },
        {
          id: 90,
          name: '90days'
        },
      ],
      selectedDays: 1,
      storeID: 0,
      storeSettings: null,
      policyLinkText: null,
      policyText: null,
      updateEditor: null,
      dialogPreview: false,
      logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
      focusNext(elem) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements.item(
          currentIndex < elem.form.elements.length - 1 ?
          currentIndex + 1 :
          0
        ).focus();
      },
      policyLinkTextRules: ruleValidMinMax('purchasePolicyLinkTextPlaceholder', 2, 70),
      organizationVatNumber: '',
      organizationPeppolNumber: '',
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
    dialog: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
  },
  created() {
    this.fetchStoreSettings()
  },
  methods: {
    onDialogClose() {
      this.$emit('close')
    },
    async fetchStoreSettings() {
      try {
        const response = await getStoreSettings(this.spaceId);
        if (response.status == 200) {
          this.storeSettings = response.data.data
          this.firstName = response.data.data.attributes.first_name
          this.lastName = response.data.data.attributes.last_name
          this.email = response.data.data.attributes.email
          this.organizationName = response.data.data.attributes.organization_name
          this.organizationNumber = response.data.data.attributes.organization_number
          this.organizationVatNumber = response.data.data.attributes.vat_number
          this.organizationPeppolNumber = response.data.data.attributes.peppol_number
          this.address = response.data.data.attributes.address
          this.city = response.data.data.attributes.city
          this.postCode = response.data.data.attributes.postal_code
          this.country = response.data.data.attributes.country
          this.accountName = response.data.data.attributes.account_number
          this.websiteUrl = response.data.data.attributes.website
          this.selectedDays = response.data.data.attributes.due_days
          this.phoneNumber = response.data.data.attributes.phone_number
          this.storeID = response.data.data.id
          this.selectedDays = response.data.data.attributes.due_days
          this.policyLinkText = response.data.data.attributes.policy_link_text
          this.policyText = response.data.data.attributes.policy_text
          this.updateEditor = Date.now()
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async createStoreSettings() {
      this.valid = this.$refs.form.validate()
      if (this.valid) {
        try {
          let data = {
            data: {
              type: "store-settings",
              attributes: {
                'organization_name': this.organizationName,
                'organization_number': this.organizationNumber,
                'vat_number': this.organizationVatNumber,
                'peppol_number': this.organizationPeppolNumber,
                'address': this.address,
                'city': this.city,
                'postal_code': this.postCode,
                'country': this.country,
                'first_name': this.firstName,
                'last_name': this.lastName,
                'email': this.email,
                'phone_number': this.phoneNumber,
                'website': this.websiteUrl,
                'account_number': this.accountName,
                'due_days': this.selectedDays,
                'policy_link_text': this.policyLinkText,
                'policy_text': this.policyText == null || this.policyText == '<p></p>' ? null : this.policyText

              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                }
              }
            }
          };

          var response = await createStoreSettings(data);
          if (response.status == 201) {
            this.alertMsg = i18n.t('createStoreSettingsSuccess')
            this.alertType = 'success'

            this.$emit('proceedAction', this.alertMsg, this.alertType)
            this.$emit('close')
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async updateStoreSettings() {
      this.valid = this.$refs.form.validate()
      if (this.valid) {
        try {
          let data = {
            data: {
              type: "store-settings",
              id: this.storeID,
              attributes: {
                'organization_name': this.organizationName,
                'organization_number': this.organizationNumber,
                'vat_number': this.organizationVatNumber,
                'peppol_number': this.organizationPeppolNumber,
                'address': this.address,
                'city': this.city,
                'postal_code': this.postCode,
                'country': this.country,
                'first_name': this.firstName,
                'last_name': this.lastName,
                'email': this.email,
                'phone_number': this.phoneNumber,
                'website': this.websiteUrl,
                'account_number': this.accountName,
                'due_days': this.selectedDays,
                'policy_link_text': this.policyLinkText,
                'policy_text': this.policyText == null || this.policyText == '<p></p>' ? null : this.policyText
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                }
              }
            }
          };

          var response = await updateStoreSettings(data, this.storeID);
          if (response.status == 200) {
            this.alertMsg = i18n.t('updateStoreSettingsSuccess')
            this.alertType = 'success'
            this.$emit('proceedAction', this.alertMsg, this.alertType)
            this.$emit('close')
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    updateContent(content) {
      if (content != '') {
        this.policyText = content
      }
    },
  },
}

</script>